import React from 'react';

import styles from './Error.module.css';

const ERROR_MESSAGE = 'Something went wrong. Please try again.';

export const Error = () => {
  return <p className={styles.errorMessage}>{ERROR_MESSAGE}</p>;
};
